import React from 'react'
import { Text } from '@afterpaytouch/core'
import { Trans } from 'next-i18next'
import { useTranslation } from '../../../../utils/convergence'
import { TermLink } from '../../../../component/TermLink/TermLink'
import { TrackingEvent } from '../../../../model/monitoring'
import styles from './styles.module.css'
import { useMonitoringWithEnduringEventProperties } from '../../../../integrations/monitoring'

export const Terms = (): JSX.Element => {
  const { t } = useTranslation()
  const { logEvent } = useMonitoringWithEnduringEventProperties()

  const components = {
    terms: (
      <TermLink
        key='summary-terms-of-service'
        href={t('common:termsOfServiceUrl')}
        color='Black'
        fontFace={'CashSansMono'}
        onClick={() => logEvent(TrackingEvent.PRESSED_SUMMARY_PAGE_TERMS_LINK, { outboundLink: t('common:termsOfServiceUrl') })}
      />
    ),
  }

  return (
    <div className={styles.container}>
      <Text color='Gray40' size='XXS' fontFace='CashSansMono'>
        <Trans i18nKey='summary:terms_appleRetail' components={components} />
      </Text>
    </div>
  )
}
